<template>
    <section class="comp_checkin_new">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading"><span>{{ $t('accommodation') }}</span></h1>
                    </div>
                    <div class="col mod--flex-grow mod--right">

                    </div>
                </header>
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <part-checkin-edit></part-checkin-edit>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'bookings-new',
    data() {
        return {}
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/checkin-new.vue